export const inventoryControl = {
	label: "Inventário",
};
